import React from 'react';
import NotFoundContent from "../components/NotFoundContent";

const NotFound = () => {
    return (
        <div>
            <NotFoundContent/>
        </div>
    );
};

export default NotFound;